<template>
  <div class="form-group">
    <label>
      <slot />
    </label>
    <textarea
      class="form-control mb-2"
      rows="3"
      :id="id"
      :name="name"
      :placeholder="placeholder"
      :value="modelValue"
      :required="isRequired"
      @blur="blurValidation"
      @keyup="endWriteValidation($event.target.value)"
      @paste="pasteDetectAction"
      @input="pasteAction($event.target.value)"
    />
    <argon-alert size="sm" color="error" v-if="showError">
      <strong>{{ `'${name}'` }}</strong> Es un campo obligatorio!
    </argon-alert>
  </div>
</template>

<script>
import ArgonAlert from "./ArgonAlert.vue";

export default {
  name: "argon-textarea",
  components: { ArgonAlert },
  props: {
    id: String,
    placeholder: String,
    modelValue: String,
    name: String,
    isRequired: Boolean,
  },
  data() {
    return {
      showError: false,
      pasteDetect: false,
      valid: this.inputValid(),
      timeout: setTimeout(() => {
        clearTimeout(this.timeout);
      }, 1),
    };
  },
  emits: ["update:modelValue", "valid"],
  methods: {
    pasteAction(value) {
      if (this.pasteDetect) {
        if (value.length !== 0) {
          this.showError = false;
          this.$emit("valid", { inputIndex: parseInt(this.id), valid: true });
        } else {
          this.showError = true;
          this.$emit("valid", { inputIndex: parseInt(this.id), valid: false });
        }
        this.$emit("update:modelValue", value);
        this.pasteDetect = false;
      }
    },
    pasteDetectAction() {
      this.pasteDetect = true;
    },
    blurValidation() {
      if (this.isRequired) {
        if (this.modelValue.length === 0) {
          this.showError = true;
          this.$emit("valid", { inputIndex: parseInt(this.id), valid: false });
        }
      }
    },
    endWriteValidation(value) {
      this.showError = false;
      this.$emit("update:modelValue", value);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.isRequired) {
          if (value.length !== 0) {
            this.$emit("update:modelValue", value);
            this.$emit("valid", { inputIndex: parseInt(this.id), valid: true });
          } else {
            this.showError = true;
            this.$emit("valid", {
              inputIndex: parseInt(this.id),
              valid: false,
            });
          }
        }
        clearTimeout(this.timeout);
      }, 700);
    },
    inputValid() {
      let valid = true;
      if (this.isRequired) {
        if (this.modelValue.length === 0) {
          valid = false;
          this.$emit("valid", { inputIndex: parseInt(this.id), valid: false });
        } else valid = true;
      }
      return valid;
    }
  },
};
</script>